import { useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { setIsDiscountInputEnabled, setDiscountAmount, setDiscountCodeErrorMessage } from '../../state/DiscountCode/discountCodeSlice';
import { applyDiscount } from './ApplyDiscountHelpers';
import { useSelector, useDispatch } from 'react-redux';
import { usePaymentFormContext } from '../../context/PaymentFormContext';
import { getBuyerOverridesLineItems } from '../../state/BuyerOverrides/selectors';
import { setErrorMessages } from '../../state/errorMessagesSlice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const RemoveDiscountCodeButton = ({
  checkoutSession,
  isIframePreviewUrl,
  client,
  minimumAmount,
  paymentMethod,
  checkoutFees
}) => {
  const buyerOverridesLineItems = useSelector(getBuyerOverridesLineItems);
  const reduxDispatch = useDispatch();
  const {
    dispatch
  } = usePaymentFormContext();
  const handleDiscountCodeRemoval = useCallback(() => {
    reduxDispatch(setIsDiscountInputEnabled(false));
    dispatch({
      type: 'setIsDiscountCodeApplied',
      data: false
    });
    reduxDispatch(setDiscountAmount({
      discountedValue: 0,
      discountedPercentage: 0
    }));
    reduxDispatch(setDiscountCodeErrorMessage(''));
    reduxDispatch(setErrorMessages({
      invalidDiscountCode: {
        isError: false
      }
    }));
    dispatch({
      type: 'setDiscountCodeError',
      data: false
    });

    // reset total with no discount code
    applyDiscount({
      isDiscountRemoved: true,
      buyerOverrides: {
        lineItems: buyerOverridesLineItems
      },
      checkoutSession,
      isIframePreviewUrl,
      dispatch,
      reduxDispatch,
      client,
      minimumAmount,
      paymentMethod,
      checkoutFees
    });
  }, [reduxDispatch, dispatch, buyerOverridesLineItems, checkoutSession, isIframePreviewUrl, client, minimumAmount, paymentMethod, checkoutFees]);
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "remove-discount-code-button",
    padding: "0",
    borderRadius: "0",
    paddingBlockStart: "200",
    use: "transparent",
    onClick: handleDiscountCodeRemoval,
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.removeDiscountCode"
    })
  });
};
export default RemoveDiscountCodeButton;